import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=ccc6192e&scoped=true"
import script from "./DashboardPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DashboardPage.vue?vue&type=style&index=0&id=ccc6192e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc6192e",
  null
  
)

export default component.exports